module.exports = __webpack_public_path__ + "img/icon-black-Wetwall.877e9868.png";